/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminListCustomerMoneyPools} from '../api'

export const useMutationAdminListCustomerMoneyPools = createReactQueryMutationHook('adminListCustomerMoneyPools', adminListCustomerMoneyPools)
